// Brand wine is the swatch shown before a salon picks its own category colour.
export const DEFAULT_CATEGORY_COLOR = "#8C1C4D";

export const categoryColorFormValue = (color) => (
  typeof color === "string" && color.trim() !== "" ? color.trim() : ""
);

export const categoryColorPayload = (color) => (
  typeof color === "string" && color.trim() !== "" ? color.trim() : null
);
